import ReceiptType from '../../../../../component/systemMaster/sponsorBank/sponsorBankPayment/ReceiptType/ReceiptType';
const ReceiptTypes=()=>{
    return <ReceiptType/>
}
export default ReceiptTypes;